import { Button } from "@website/ui/button";
import { Skeleton } from "@website/ui/skeleton";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { memo } from "react";

const Component = () => {
  const router = useRouter();

  return (
    <div className="bg-on-color-high-emphasis shadow-1 flex min-w-[218px] flex-col overflow-hidden rounded-xl xl:max-w-[1104px]">
      <div className="flex flex-col">
        <div className="border-outline-thin flex h-[96px] flex-row justify-between gap-2 border-b p-4">
          <div className="flex w-36 flex-col gap-1">
            <Skeleton height={20} shape="rectangle" />
            <Skeleton height={20} shape="rectangle" />
          </div>
          <div className="flex cursor-pointer flex-row gap-1">
            <Skeleton height={20} shape="square" />
          </div>
        </div>
        <div className="flex flex-col items-center justify-between pb-4 pt-3 lg:min-h-[68px] lg:flex-row lg:px-4 lg:pt-4">
          <div className="flex w-full flex-row flex-wrap items-center justify-between">
            <div className="ml-4 lg:order-4 lg:mr-4 ltr:mr-4 lg:ltr:ml-0">
              <Skeleton height={20} shape="square" />
            </div>
            <div className="bg-outline-thin mb-4 mt-3 block h-px w-full lg:hidden" />
            <Button
              className="ml-4 w-[133px] lg:order-5 lg:col-span-2 lg:m-0 lg:w-[94px] ltr:mr-4"
              color="disabled"
              size="small"
            >
              {`رزرو ${numberConvert(1, { locale: router.locale })} اتاق`}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export const HotelReserveCardSkeleton = memo(Component, deepCompare);
